import { render, staticRenderFns } from "./Vacation.vue?vue&type=template&id=0c9547c8&"
import script from "./Vacation.vue?vue&type=script&lang=js&"
export * from "./Vacation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/soeren.lyhs/_htdocs/privat/meinbubu/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpeedDial } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VLayout,VSpeedDial})
